import CreateLotteryPage from "./CreateLottery";

export default CreateLotteryPage;
